import { Autocomplete, TextField } from "@mui/material";
import { useMemo } from "react";
import { useLidarClearance } from "./LidarClearanceContext";
import type { LidarClearanceSystem } from "./schemas";
import t from "./translations";

type Props = {
  region: string;
  value: number | null;
  onChange: (systemId: number | null) => void;
};

export default function SystemPicker({ region, value, onChange }: Props) {
  const { systems } = useLidarClearance();

  const options = useMemo(
    () =>
      systems
        .filter((system) => system.region === region)
        .sort((a, b) => a.name.localeCompare(b.name)),
    [systems, region]
  );

  const selected = options.find((system) => system.id === value) ?? null;

  return (
    <Autocomplete<LidarClearanceSystem>
      options={options}
      value={selected}
      onChange={(_event, next) => onChange(next?.id ?? null)}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      renderInput={(params) => (
        <TextField {...params} label={t.SelectSystemLabel} />
      )}
      sx={{ width: 280 }}
    />
  );
}
